import React from 'react';

import { CustomCellRendererProps } from 'ag-grid-react';

import { LOAD_DONOR_PARTNERS_OPTION_VALUES } from '@/enums';
import { usePastDueStatus } from '@/hooks/usePastDueStatus';

import './PastDueCellRenderer.css';

export const PastDueCellRenderer = (
  params: CustomCellRendererProps,
): React.ReactElement => {
  try {
    const {
      isPastDue,
      ownerPastDue,
      partnersPastDue,
      hasAging60,
      hasOver90Days,
      isLocked,
      overrideActiveUntil,
    } = usePastDueStatus(
      params.data.owner,
      params.data.partnerships ?? [],
      params.data.loadDonorPartners === LOAD_DONOR_PARTNERS_OPTION_VALUES.NO,
    );

    const hasBadge = isPastDue;

    const getBadgeStyle = () => {
      if (isLocked)
        return {
          colorClass: 'bg-red-500',
          title: hasOver90Days
            ? 'Over 90 days – restricted or override expired'
            : 'Restricted/closed – TOG 90-day status',
        };
      if (overrideActiveUntil)
        return {
          colorClass: 'bg-red-500',
          title: `Over 90 days – override active until ${overrideActiveUntil}`,
        };
      if (hasAging60)
        return { colorClass: 'bg-yellow-500', title: 'Past due (60+ days)' };
      return { colorClass: 'bg-red-500', title: 'Past due' };
    };

    const { colorClass, title } = getBadgeStyle();

    return (
      <span className="custom-cell__past-due">
        {hasBadge && (
          <span
            className={`past-due-badge mr-2 inline-flex h-5 w-5 items-center justify-center rounded-full text-xs font-semibold text-white ${colorClass}`}
            title={title}
          >
            $
          </span>
        )}
        {params.value ?? ''}
      </span>
    );
  } catch (error) {
    console.error('Error in PastDueCellRenderer:', error);
    return <span className="custom-cell__past-due">{params.value ?? ''}</span>;
  }
};
